import { useEffect } from 'react';

const STYLE_ID = 'spectrum-tray-fix';

const TRAY_FIX_CSS = `
div[class*="spectrum-Tray-wrapper"] {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-end !important;
    overflow: visible !important;
    z-index: 99999 !important;
}
div[class*="spectrum-Tray"][class*="spectrum-overlay"]:not([class*="wrapper"]) {
    position: static !important;
    top: unset !important;
    left: unset !important;
    right: unset !important;
    bottom: unset !important;
    width: 100% !important;
    height: auto !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    background: #1e1e1e !important;
    border-top: 1px solid #525252 !important;
    border-radius: 10px 10px 0 0 !important;
    padding: 10px 0 !important;
    margin: 0 !important;
}
div[class*="spectrum-Underlay"] {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 99998 !important;
}
/* Kill ALL transforms, transitions, and animations on the tray and everything inside it */
div[class*="spectrum-Tray-wrapper"],
div[class*="spectrum-Tray-wrapper"] *,
div[class*="spectrum-Underlay"] {
    transform: none !important;
    -webkit-transform: none !important;
    transition: none !important;
    -webkit-transition: none !important;
    animation: none !important;
    -webkit-animation: none !important;
}
`;

export function useSpectrumTrayFix() {
    useEffect(() => {
        if (document.getElementById(STYLE_ID)) return;
        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = TRAY_FIX_CSS;
        document.head.appendChild(style);
        return () => style.remove();
    }, []);
}
